<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span class="title dialog-title" i18n>Материалы на замену</span>

      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container *ngIf="data$ | async as data">
      <mat-form-field
        class="w-full dense-input no-label no-subscript py-2 px-2"
        appearance="outline"
        floatLabel="never">
        <input #filter id="filter" type="text" matInput i18n-placeholder placeholder="Поиск" />
        <mat-icon matPrefix class="secondary-text">search</mat-icon>
      </mat-form-field>
      <table *ngIf="!data.error" mat-table #table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="preview">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <div class="h-full w-full flex flex-col justify-center">
              <div
                class="preview color-preview"
                *ngIf="item.color"
                [ngStyle]="{ 'background-color': '#' + item.color }"></div>

              <img
                *ngIf="item.textureName && !item.color"
                class="preview"
                src="{{ item.cropTextureLink }}"
                (click)="openTextureViewerDialog(item.textureLink)"
                onerror="this.onerror=null; this.src='./assets/images/no-image.svg'" />

              <mat-icon *ngIf="!item.textureName && !item.color" class="s-40 secondary-text preview" svgIcon="no_image">
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th i18n mat-header-cell *matHeaderCellDef>Название</th>
          <td mat-cell *matCellDef="let item">{{ extractMaterialName(item.materialName) }}</td>
        </ng-container>

        <ng-container matColumnDef="article">
          <th i18n mat-header-cell *matHeaderCellDef>Артикул</th>
          <td mat-cell *matCellDef="let item">{{ extractMaterialCode(item.materialName) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr
          mat-row
          (click)="selection.toggle(row)"
          [ngClass]="{ 'accent-50': selection.isSelected(row) }"
          *matRowDef="let row; columns: displayColumns"></tr>
      </table>

      <div *ngIf="!data.error && !data.result">Loading…</div>

      <div *ngIf="data.error">
        <csl-no-data-display></csl-no-data-display>
      </div>
    </ng-container>
  </div>

  <mat-divider> </mat-divider>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row-reverse justify-between items-center">
    <div>
      <button mat-raised-button class="mat-accent" (click)="dialogRef.close(selection.selected)" i18n>ОК</button>
      <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
    </div>

    <button
      *ngIf="data.cuttingOptions && data.cuttingOptions.cuttingProductSettings.addMaterialsFromMatBase"
      i18n-matTooltip
      matTooltip="Выбрать материал из базы материалов"
      mat-icon-button
      (click)="openMaterialBaseDialog()">
      <mat-icon>layers</mat-icon>
    </button>
  </div>
</div>
